import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Garantia() {
  return <section className="py-16 bg-white border-t-4 border-celeste relative" data-id="element-119">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-120">
        <FadeIn data-id="element-121">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-celeste/10 rounded-full mb-6" data-id="element-122">
            <ShieldCheck className="w-10 h-10 text-celeste" data-id="element-123" />
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-black mb-6 uppercase text-navy" data-id="element-124">
            Garantía total de 30 días
          </h2>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-125">
            Si en 30 días no notás ninguna mejora en tu juego zurdo, te
            devolvemos el 100% de tu dinero. Nos escribís por correo, te
            devolvemos el pago. Sin formularios, sin justificaciones, sin
            demoras.
          </p>
          <div className="bg-lightbg p-6 rounded-xl border border-gray-200 mb-6" data-id="element-126">
            <p className="text-gray-600 italic" data-id="element-127">
              "Menos del 2% de quienes compran piden devolución. Lo decimos para
              que entiendas que el producto funciona."
            </p>
          </div>
          <p className="font-bold text-navy text-lg" data-id="element-128">
            El único riesgo real es seguir siendo el zurdo que no explota su
            mayor ventaja.
          </p>
        </FadeIn>
      </div>
    </section>;
}